import React from 'react'

const Loader = () => (
  <div id='loader'>
    ...
  </div>
)

export default Loader
